import type {PressReleasePreview} from '@openapi/press-release';
import type {
  CompanyDetail,
  PressReleasesByCompanyIdDataInner,
  StoriesByCompanyIdDataInner,
} from '@openapi/prtimes';
import {useGetPreviewMediaType} from '../../context/preview-media-type';
import {type PreviewDeviceType} from '../../hooks/use-preview-device-state';
import {WebPreview} from './web-preview';
import {SocialPreview} from './social-preview';
import {MailPreview} from './mail-preview';

type Props = {
  readonly pressRelease: PressReleasePreview;
  readonly company: CompanyDetail;
  readonly latestPressReleases?: PressReleasesByCompanyIdDataInner[];
  readonly latestStories?: StoriesByCompanyIdDataInner[];
  readonly device: PreviewDeviceType;
};

export function PreviewUi({
  pressRelease,
  company,
  latestPressReleases,
  latestStories,
  device,
}: Props) {
  const mediaType = useGetPreviewMediaType();

  switch (mediaType) {
    case 'web': {
      return (
        <WebPreview
          pressRelease={pressRelease}
          company={company}
          device={device}
          latestPressReleasesData={latestPressReleases}
          latestStoriesData={latestStories}
        />
      );
    }

    case 'social': {
      return <SocialPreview pressRelease={pressRelease} />;
    }

    case 'mail': {
      return <MailPreview pressRelease={pressRelease} device={device} />;
    }
  }
}
